module.exports = __webpack_public_path__ + "static/media/logo-odonto.e88c8888.svg";